<script lang="ts">
    import { clickOutside } from "svelte-outside";
    import { getContext } from "svelte";
    import { mapMenuVisibleStore, openedMenuStore } from "../../../Stores/MenuStore";
    import { LL } from "../../../../i18n/i18n-svelte";
    import { createFloatingUiActions } from "../../../Utils/svelte-floatingui";
    import { triggerClickOnEnterOrSpace } from "../../../Utils/svelte-a11y";
    import ActionBarButton from "../ActionBarButton.svelte";
    import MapToolsIcon from "../../Icons/meta/MapToolsIcon.svelte";
    import MapSubMenuContent from "./MapSubMenuContent.svelte";
    import ProfileMenuAccordeon from "./ProfileMenuAccordeon.svelte";

    // The ActionBarButton component is displayed differently in the menu.
    // We use the context to decide how to render it.
    // setContext("inMenu", true);

    const inProfileMenu = getContext("profileMenu");

    // Useless properties. They are here only to avoid a warning because we set the "first" or "classList" prop on all the right menu items
    interface Props {
        // svelte-ignore unused-export-let
        first?: boolean;
        // svelte-ignore unused-export-let
        classList?: string;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { first = undefined, classList = undefined }: Props = $props();

    const [floatingUiRef, floatingUiContent] = createFloatingUiActions(
        {
            placement: "bottom-end",
            //strategy: 'fixed',
        },
        8,
    );

    function closeMapMenu() {
        openedMenuStore.close("mapMenu");
    }
</script>

{#if $mapMenuVisibleStore}
    {#if !inProfileMenu}
        <div
            data-testid="map-menu"
            use:floatingUiRef
            role="button"
            tabindex="0"
            aria-label="Карта"
            onclick={(event) => {
                event.preventDefault();
                openedMenuStore.toggle("mapMenu");
            }}
            onkeydown={triggerClickOnEnterOrSpace}
        >
            <ActionBarButton classList="group/btn-map" disabledHelp state="normal" bottomTooltip ariaLabel="Карта">
                <MapToolsIcon />
            </ActionBarButton>
        </div>
        {#if $openedMenuStore === "mapMenu"}
            <div
                class="absolute bg-mlight/80 shadow-light rounded-md2 backdrop-blur w-auto max-w-full text-mdark"
                data-testid="map-sub-menu"
                use:floatingUiContent
                use:clickOutside={closeMapMenu}
            >
                <div class="p-1 m-0">
                    <MapSubMenuContent />
                </div>
            </div>
        {/if}
    {:else}
        <ProfileMenuAccordeon label={$LL.actionbar.map()} classes="hidden narrow:block">
            <MapSubMenuContent />
        </ProfileMenuAccordeon>
    {/if}
{/if}
